import httpService from "./httpService";

export default {
  findById(id) {
    return httpService.get("vbOutgoingDocCopy/findById/" + id);
  },

  create(form) {
    return httpService.post("vbOutgoingDocCopy", form)

  },
  saveCopy(form) {
    return httpService.post("vbOutgoingDocCopy/saveCopy", form)

  },
  delete(id) {
    return httpService.delete("vbOutgoingDocCopy/" + id
    );
  }
};



// WEBPACK FOOTER //
// ./src/services/vbOutgoingDocCopyService.js